<div class="crm-page shipments-page">
  <app-header
    [title]="'TITLES.SHIPMENTS' | translate"
    [subtitle]="'COMPONENTS.SHIPMENTS.SUBTITLE' | translate"
  >
    <div header-actions class="crm-page__header-actions">
      <div class="hidden lg:block">
        <app-navbar-profile-info></app-navbar-profile-info>
      </div>
    </div>
  </app-header>

  <div class="crm-page__content px-4 py-6 md:px-8 md:py-8">
    @if (isLoading) {
      <div class="crm-page__overlay">
        <div class="shipments-page__spinner" aria-hidden="true"></div>
        <span class="sr-only">{{ "MESSAGES.LOADING" | translate }}</span>
      </div>
    }

    <div class="crm-page__toolbar">
      <div class="crm-list-search form-search">
        <div class="input-search">
          <input
            type="text"
            [value]="searchTerm"
            [placeholder]="'COMPONENTS.SHIPMENTS.SEARCH_PLACEHOLDER' | translate"
            [attr.aria-label]="'COMPONENTS.SHIPMENTS.SEARCH_PLACEHOLDER' | translate"
            (input)="onSearchChange($any($event.target).value)"
          />
          <span class="search-icon" aria-hidden="true">
            <img src="assets/img/search.svg" alt="" />
          </span>
        </div>
      </div>

      @if (canCreateShipment$ | async) {
        <button
          type="button"
          class="crm-page__action-button crm-page__action-button--primary"
          (click)="openCreateModal()"
        >
          + {{ "COMPONENTS.SHIPMENTS.BUTTONS.CREATE" | translate }}
        </button>
      }
    </div>

    @if (errorMessageKey) {
      <app-card-shell padding="lg">
        <div class="shipments-page__error">
          <div>
            <h2 class="shipments-page__error-title">{{ "ERRORS.UNKNOWN_ERROR" | translate }}</h2>
            <p class="shipments-page__error-text">{{ errorMessageKey | translate }}</p>
          </div>

          <button type="button" class="crm-page__action-button" (click)="retry()">
            {{ "BUTTONS.RETRY" | translate }}
          </button>
        </div>
      </app-card-shell>
    } @else if (shipments$ | async; as shipments) {
      @if (shipments.items.length === 0) {
        <app-card-shell class="crm-page__empty-card" padding="none">
          <div class="crm-page__empty-state">
            <app-empty-content
              [showImage]="true"
              [message]="'MESSAGES.EMPTY_LIST' | translate: { param: emptyListParam[currentLang] }"
              [tooltip]="'COMPONENTS.SHIPMENTS.EMPTY_TOOLTIP' | translate"
              [textPositionClass]="'text-center'"
            />
          </div>
        </app-card-shell>
      } @else {
        <app-card-shell class="crm-page__list-card" padding="none">
          <div class="crm-table__desktop">
            <div class="crm-table__scroller">
              <table class="crm-table__table">
                <thead>
                  <tr class="crm-table__header-row">
                    <th
                      class="crm-table__header-cell"
                      appSortableHeader="number"
                      [appSortableHeaderActiveColumn]="activeSortColumn"
                      [appSortableHeaderActiveOrder]="activeSortOrder"
                      (appSortableHeaderChange)="onSortChange($event)"
                    >
                      {{ "COMPONENTS.SHIPMENTS.TABLE.NUMBER" | translate }}
                    </th>
                    <th class="crm-table__header-cell">
                      {{ "COMPONENTS.SHIPMENTS.TABLE.CUSTOMER" | translate }}
                    </th>
                    <th class="crm-table__header-cell">
                      {{ "COMPONENTS.SHIPMENTS.TABLE.ORDER" | translate }}
                    </th>
                    <th
                      class="crm-table__header-cell"
                      appSortableHeader="shipmentDate"
                      [appSortableHeaderActiveColumn]="activeSortColumn"
                      [appSortableHeaderActiveOrder]="activeSortOrder"
                      (appSortableHeaderChange)="onSortChange($event)"
                    >
                      {{ "COMPONENTS.SHIPMENTS.TABLE.DATE" | translate }}
                    </th>
                    <th class="crm-table__header-cell">
                      {{ "COMPONENTS.SHIPMENTS.TABLE.STATUS" | translate }}
                    </th>
                    <th class="crm-table__header-cell">
                      {{ "COMPONENTS.SHIPMENTS.TABLE.ACTIONS" | translate }}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  @for (shipment of shipments.items; track shipment.id) {
                    <tr class="crm-table__row">
                      <td class="crm-table__cell crm-table__cell--title">
                        <a [routerLink]="shipment.id" [title]="shipment.number">
                          {{ shipment.number }}
                        </a>
                      </td>
                      <td class="crm-table__cell" [title]="shipment.customerLabel">
                        {{ shipment.customerLabel }}
                      </td>
                      <td class="crm-table__cell" [title]="shipment.orderLabel">
                        {{ shipment.orderLabel }}
                      </td>
                      <td class="crm-table__cell" [title]="shipment.shipmentDate">
                        {{ shipment.shipmentDate ? (shipment.shipmentDate | date: "yyyy-MM-dd") : "-" }}
                      </td>
                      <td class="crm-table__cell">
                        <span
                          class="shipments-page__status-badge"
                          [class.shipments-page__status-badge--success]="shipment.statusBadgeKey === 'success'"
                          [class.shipments-page__status-badge--warning]="shipment.statusBadgeKey === 'warning'"
                        >
                          {{ shipment.statusLabelKey | translate }}
                        </span>
                      </td>
                      <td class="crm-table__cell shipments-page__row-actions">
                        @if (shipment.canMarkShipped) {
                          <button
                            type="button"
                            class="shipments-page__row-action-btn"
                            (click)="openMarkShippedModal(shipment)"
                          >
                            {{ "COMPONENTS.SHIPMENTS.BUTTONS.MARK_SHIPPED" | translate }}
                          </button>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>

          <div class="crm-page__footer shipments-page__footer--desktop">
            <app-paginator
              class="crm-page__paginator"
              [totalItems]="shipments.totalCount"
              [page]="shipments.page"
              [pageSize]="shipments.pageSize"
              [showSummary]="true"
              (pageChange)="onPageChange($event)"
              (pageSizeChange)="onChangePageSize($event)"
            />
          </div>
        </app-card-shell>

        <div class="crm-table__mobile-section">
          <div class="crm-table__mobile-list">
            @for (shipment of shipments.items; track shipment.id) {
              <article class="crm-mobile-card">
                <div class="crm-mobile-card__header">
                  <div class="crm-mobile-card__title-wrap">
                    <span class="shipments-page__mobile-accent" aria-hidden="true"></span>

                    <div class="crm-mobile-card__title-block">
                      <a
                        class="crm-mobile-card__title"
                        [routerLink]="shipment.id"
                        [title]="shipment.number"
                      >
                        {{ shipment.number }}
                      </a>
                      <span
                        class="shipments-page__status-badge"
                        [class.shipments-page__status-badge--success]="shipment.statusBadgeKey === 'success'"
                        [class.shipments-page__status-badge--warning]="shipment.statusBadgeKey === 'warning'"
                      >
                        {{ shipment.statusLabelKey | translate }}
                      </span>
                    </div>
                  </div>
                </div>

                <div class="crm-mobile-card__grid">
                  <div class="crm-mobile-card__field">
                    <p class="crm-mobile-card__label">
                      {{ "COMPONENTS.SHIPMENTS.TABLE.CUSTOMER" | translate }}
                    </p>
                    <p class="crm-mobile-card__value">{{ shipment.customerLabel }}</p>
                  </div>

                  <div class="crm-mobile-card__field">
                    <p class="crm-mobile-card__label">
                      {{ "COMPONENTS.SHIPMENTS.TABLE.ORDER" | translate }}
                    </p>
                    <p class="crm-mobile-card__value">{{ shipment.orderLabel }}</p>
                  </div>

                  <div class="crm-mobile-card__field">
                    <p class="crm-mobile-card__label">
                      {{ "COMPONENTS.SHIPMENTS.TABLE.DATE" | translate }}
                    </p>
                    <p class="crm-mobile-card__value">
                      {{ shipment.shipmentDate ? (shipment.shipmentDate | date: "yyyy-MM-dd") : "-" }}
                    </p>
                  </div>
                </div>

                @if (shipment.canMarkShipped) {
                  <div class="shipments-page__mobile-actions">
                    <button
                      type="button"
                      class="shipments-page__row-action-btn"
                      (click)="openMarkShippedModal(shipment)"
                    >
                      {{ "COMPONENTS.SHIPMENTS.BUTTONS.MARK_SHIPPED" | translate }}
                    </button>
                  </div>
                }
              </article>
            }
          </div>

          <div class="crm-page__footer shipments-page__footer--mobile">
            <app-paginator
              class="crm-page__paginator"
              [totalItems]="shipments.totalCount"
              [page]="shipments.page"
              [pageSize]="shipments.pageSize"
              [showSummary]="true"
              (pageChange)="onPageChange($event)"
              (pageSizeChange)="onChangePageSize($event)"
            />
          </div>
        </div>
      }
    }

    <app-reusable-modal
      [isOpen]="isCreateModalOpen"
      [panelClass]="'max-w-3xl'"
      [contentScoped]="true"
      [title]="'COMPONENTS.SHIPMENTS.MODAL.CREATE_TITLE' | translate"
      [subtitle]="'COMPONENTS.SHIPMENTS.MODAL.CREATE_SUBTITLE' | translate"
      (closed)="closeCreateModal()"
    >
      <app-create-shipment-modal
        [companyId]="companyId"
        [isOpen]="isCreateModalOpen"
        (cancelled)="closeCreateModal()"
        (created)="onShipmentCreated($event)"
      />
    </app-reusable-modal>

    <app-reusable-modal
      [isOpen]="isMarkShippedModalOpen"
      [panelClass]="'max-w-md'"
      [contentScoped]="true"
      [title]="'COMPONENTS.SHIPMENTS.MODAL.MARK_SHIPPED_TITLE' | translate"
      (closed)="closeMarkShippedModal()"
    >
      <div class="shipments-page__confirm">
        <p class="shipments-page__confirm-prompt">
          {{ "COMPONENTS.SHIPMENTS.MODAL.MARK_SHIPPED_PROMPT" | translate }}
        </p>
        @if (markShippedTarget) {
          <p class="shipments-page__confirm-target">
            {{ markShippedTarget.number }}
          </p>
        }
        @if (markShippedErrorKey) {
          <p class="shipments-page__confirm-error" role="alert">
            {{ markShippedErrorKey | translate }}
          </p>
        }
        <div class="shipments-page__confirm-actions">
          <button
            type="button"
            class="form-secondary-btn"
            [disabled]="isMarkShippedInFlight"
            (click)="closeMarkShippedModal()"
          >
            {{ "BUTTONS.CANCEL" | translate }}
          </button>
          <button
            type="button"
            class="form-primary-btn"
            [disabled]="isMarkShippedInFlight"
            (click)="confirmMarkShipped()"
          >
            @if (isMarkShippedInFlight) {
              {{ "COMPONENTS.SHIPMENTS.BUTTONS.MARKING_SHIPPED" | translate }}
            } @else {
              {{ "COMPONENTS.SHIPMENTS.BUTTONS.MARK_SHIPPED" | translate }}
            }
          </button>
        </div>
      </div>
    </app-reusable-modal>
  </div>
</div>
